import React, { FC } from 'react';
import { NavMenuItem } from '../SideNav';
import { setRelAttribute } from '@trip-ux/common';


export const FooterLogo: FC<NavMenuItem> = ({ ariaLabel, href, invertedLogo, logo, navId, target }) => {

  const fLogo = invertedLogo || logo
  return(
    <a className="logo-link" data-testid={navId} href={href} rel={setRelAttribute(href)} id={navId} target={target}>
      <img alt={ariaLabel} src={fLogo} />
    </a>
  )
};

FooterLogo.displayName = 'FooterLogo';
export default FooterLogo;
